import "styles/pages/page-terms.scss";

import React from "react";

import Layout from "components/Layout";
import ScrollTile from "components/ScrollTile/ScrollTile";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import VerticalScrollMenu from "components/VerticalScrollMenu/VerticalScrollMenu";
import ContactForm from "../components/ContactForm/ContactForm";

const TermsPage = ({ pageContext }) => {
  const pageContent = pageContext.pageContent;
  const seo = pageContext.seo;
  return (
    <Layout>
      <Seo title={seo.title} description={seo.metaDesc} />
      <SubpageHeader
        title={pageContext.title}
        location="Ogólne warunki sprzedaży, gwarancji i polityka prywatności"
      />
      <section className="terms-menu">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <ScrollTile
                title="Ogólne warunki sprzedaży, <br /> dostaw i zapłaty"
                icon={require("assets/icons/ows.svg").default}
                anchor="ows"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-md-4">
              <ScrollTile
                title="Ogólne warunki gwarancji, <br /> na sprzedawane towary"
                icon={require("assets/icons/owg.svg").default}
                anchor="owg"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-md-4">
              <ScrollTile
                title="Polityka prywatności"
                icon={require("assets/icons/privacy-policy.svg").default}
                anchor="polityka-prywatnosci"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
          </div>
        </div>
      </section>
      <span className="anchor" id="ows" />
      <section className="ows">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <VerticalScrollMenu
                tabs={[
                  {
                    label: "Postanowienia ogólne",
                    anchor: "postanowienia-ogolne",
                  },
                  {
                    label: "Zawarcie umowy",
                    anchor: "zawarcie-umowy",
                  },
                  {
                    label: "Ceny",
                    anchor: "ceny",
                  },
                  {
                    label: "Zapłata",
                    anchor: "zaplata",
                  },
                  {
                    label: "Dostawa",
                    anchor: "dostawa",
                  },
                  {
                    label: "Przejście ryzyka i odpowiedzialność",
                    anchor: "przejscie-ryzyka-i-odpowiedzialnosc",
                  },
                  { label: "Gwarancja", anchor: "gwarancja" },
                  {
                    label: "Zastrzeżenie własności",
                    anchor: "zastrzezenie-wlasnosci",
                  },
                  { label: "Siła wyższa", anchor: "sila-wyzsza" },
                  {
                    label: "Ochrona danych osobowych",
                    anchor: "ochrona-danych-osobowych",
                  },
                  {
                    label: "Postanowienia końcowe",
                    anchor: "postanowienia-koncowe",
                  },
                ]}
              />
            </div>
            <div className="col-md-9">
              <div
                className="terms-content"
                dangerouslySetInnerHTML={{ __html: pageContent.ows }}
              />
            </div>
          </div>
        </div>
      </section>
      <span className="anchor" id="owg" />
      <section className="owg">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <VerticalScrollMenu
                tabs={[
                  {
                    label: "Definicje",
                    anchor: "definicje",
                  },
                  {
                    label:
                      "Okres obowiązywania i zakres terytorialny gwarancji",
                    anchor:
                      "okres-obowiazywania-i-zakres-terytorialny-gwarancji",
                  },
                  {
                    label: "Zakres gwarancji",
                    anchor: "zakres-gwarancji",
                  },
                  {
                    label: "Obowiązki gwaranta",
                    anchor: "obowiazki-gwaranta",
                  },
                  {
                    label: "Zgłoszenie gwarancyjne",
                    anchor: "zgloszenie-gwarancyjne",
                  },
                  {
                    label: "Wyłączenia",
                    anchor: "wylaczenia",
                  },
                  {
                    label: "Postanowienia końcowe",
                    anchor: "postanowienia-koncowe-gwarancji",
                  },
                ]}
              />
            </div>
            <div className="col-md-9">
              <div
                className="terms-content"
                dangerouslySetInnerHTML={{ __html: pageContent.owg }}
              />
            </div>
          </div>
        </div>
      </section>
      <span className="anchor" id="polityka-prywatnosci" />
      <section className="privacy-policy">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <VerticalScrollMenu
                tabs={[
                  {
                    label:
                      "Kto jest administratorem danych osobowych i jak się z nim skontaktować?",
                    anchor:
                      "kto-jest-administratorem-danych-osobowych-i-jak-sie-z-nim-skontaktowac",
                  },
                  {
                    label: "Skąd pozyskujemy Państwa dane?",
                    anchor: "skad-pozyskujemy-panstwa-dane",
                  },
                  {
                    label: "Jakie dane przetwarzamy?",
                    anchor: "jakie-dane-przetwarzamy",
                  },
                  {
                    label:
                      "W jakim celu i na jakich podstawach prawnych przetwarzamy dane?",
                    anchor:
                      "w-jakim-celu-i-na-jakich-podstawach-prawnych-przetwarzamy-dane",
                  },
                  {
                    label: "Komu przekazujemy dane?",
                    anchor: "komu-przekazujemy-dane",
                  },
                  {
                    label: "Zabezpieczenia danych",
                    anchor: "zabezpieczenia-danych",
                  },
                  {
                    label: "Jak długo przetwarzamy dane osobowe?",
                    anchor: "jak-dlugo-przetwarzamy-dane-osobowe",
                  },
                  {
                    label: "Jakie są Państwa prawa?",
                    anchor: "jakie-sa-państwa-prawa",
                  },
                  {
                    label:
                      "Prawo do sprzeciwu wobec przetwarzania danych (Art. 21 RODO)",
                    anchor: "prawo-do-sprzeciwu-wobec-przetwarzania-danych",
                  },
                  {
                    label: "Polityka cookies",
                    anchor: "polityka-cookies",
                  },
                  {
                    label: "Newsletter",
                    anchor: "newsletter",
                  },
                  {
                    label: "Przetwarzanie danych przez podmioty trzecie",
                    anchor: "przetwarzanie-danych-przez-podmioty-trzecie",
                  },
                  {
                    label: "Zmiany Polityki Prywatności",
                    anchor: "zmiany-polityki-prywatnosci",
                  },
                ]}
              />
            </div>
            <div className="col-md-9">
              <div
                className="terms-content"
                dangerouslySetInnerHTML={{ __html: pageContent.privacyPolicy }}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="terms-contact">
        <ContactForm subject="OWS/OWG/PP" />
      </section>
    </Layout>
  );
};

export default TermsPage;
